// src/components/practice/ExamTimer.jsx
import React from 'react';

const ExamTimer = ({ timeRemaining, sectionName, isWarning, isCritical, totalTime, compact = false, inline = false }) => {
  const formatTime = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;

    if (hours > 0) {
      return `${hours}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    }
    return `${minutes}:${secs.toString().padStart(2, '0')}`;
  };

  const progressRemaining = totalTime ? (timeRemaining / totalTime) * 100 : 100;

  const getRingColor = () => {
    if (isCritical) return '#ef4444';
    if (isWarning) return '#f59e0b';
    return '#000000';
  };

  // Different sizes for different modes
  const size = inline ? 100 : (compact ? 120 : 180);
  const radius = inline ? 40 : (compact ? 50 : 70);
  const strokeWidth = inline ? 7 : (compact ? 8 : 12);
  const fontSize = inline ? '1.125rem' : (compact ? '1.25rem' : '2rem');
  const labelSize = inline ? '8px' : (compact ? '10px' : '0.75rem');

  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference - (progressRemaining / 100) * circumference;

  return (
    <div className={`flex ${inline ? 'flex-row items-center gap-2' : 'flex-col items-center'} ${!compact && !inline ? 'py-4' : ''}`}>
      <div className="relative flex-shrink-0" style={{ width: `${size}px`, height: `${size}px` }}>
        <svg
          className="transform -rotate-90 absolute inset-0"
          style={{ width: `${size}px`, height: `${size}px` }}
        >
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            stroke="rgba(0, 0, 0, 0.08)"
            strokeWidth={strokeWidth}
            fill="none"
          />
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            stroke={getRingColor()}
            strokeWidth={strokeWidth}
            fill="none"
            strokeDasharray={circumference}
            strokeDashoffset={strokeDashoffset}
            strokeLinecap="round"
            style={{
              transition: 'stroke-dashoffset 1s linear, stroke 0.3s ease'
            }}
          />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <span
            className="font-mono font-bold"
            style={{
              fontSize: fontSize,
              color: '#000000',
              lineHeight: '1'
            }}
          >
            {formatTime(timeRemaining)}
          </span>
          {!inline && (
            <span
              className={`font-medium tracking-wider ${compact ? 'mt-0.5' : 'mt-1'}`}
              style={{
                fontSize: labelSize,
                color: 'rgba(0, 0, 0, 0.5)',
                letterSpacing: '0.1em'
              }}
            >
              {sectionName.toUpperCase()}
            </span>
          )}
        </div>
      </div>

      {!compact && !inline && (
        <>
          {isCritical && (
            <div className="mt-3 text-xs font-bold tracking-widest" style={{ color: '#ef4444' }}>
              🔥 KRITISCH
            </div>
          )}
          {isWarning && !isCritical && (
            <div className="mt-3 text-xs font-semibold tracking-widest" style={{ color: '#f59e0b' }}>
              ⚠️ WARNUNG
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default ExamTimer;